/* 注册全局自定义组件 */
import Vue from 'vue'
import tableCellIndicator from './table-cell-indicator.vue'
import emptyMaskLayer from './empty-mask-layer.vue'
import feedback from '../pages/company/components/feedback.vue'

Vue.component('empty-mask-layer', emptyMaskLayer)
Vue.component('table-cell-indicator', tableCellIndicator)
Vue.component('feedback', feedback)
